import { ButtonProps } from '../../components/Button/types'
import { Form } from '../../components/Form'

export const Next = (props: ButtonProps) => (
  <Form.Submit type="submit" {...props} />
)
